module.exports = "../../static/img/iwk-icon-w33.c888629.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/notification-bubble-icon/iwk-icon-w33.png
// module id = 810
// module chunks = 1